var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "unlock-login" }, [
    !_vm.isPhone
      ? _c("div", { staticClass: "login-container" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "login-form-container" },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === "inputEmail",
                      expression: "active === 'inputEmail'",
                    },
                  ],
                  ref: "emailForm",
                  staticClass: "login-form",
                  attrs: {
                    model: _vm.emailForm,
                    "auto-complete": "on",
                    "label-position": "top",
                  },
                },
                [
                  _c("div", { staticClass: "title-container" }, [
                    _c("h3", { staticClass: "title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.reset
                            ? "Request Password Reset"
                            : "Forgot your password?"
                        )
                      ),
                    ]),
                    _c("h4", { staticClass: "tips mb48" }, [
                      _vm._v(
                        "Enter your email address below, and we'll send you a link to reset your password."
                      ),
                    ]),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "login-form-item mb48",
                      attrs: {
                        prop: "email",
                        label: "Email",
                        rules: {
                          validator: _vm.validateEmail,
                          trigger: "blur",
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        ref: "email",
                        staticClass: "login-input",
                        attrs: {
                          placeholder: "Email Address",
                          name: "email",
                          type: "text",
                          tabindex: "1",
                          "auto-complete": "on",
                          size: "default",
                        },
                        model: {
                          value: _vm.emailForm.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.emailForm, "email", $$v)
                          },
                          expression: "emailForm.email",
                        },
                      }),
                      _c(
                        "h4",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isNotRegistered,
                              expression: "isNotRegistered",
                            },
                          ],
                          staticClass: "tips red",
                        },
                        [
                          _vm._v(
                            "The email you entered is not registered. Please try again."
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "100%",
                        "margin-bottom": "30px",
                        "font-weight": "600",
                      },
                      attrs: {
                        loading: _vm.loading,
                        type: "info",
                        size: "default",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.sendResetLink($event)
                        },
                      },
                    },
                    [_vm._v("Send Reset Link")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === "checkEmail",
                      expression: "active === 'checkEmail'",
                    },
                  ],
                  staticClass: "login-form",
                },
                [
                  _vm._m(1),
                  _vm._m(2),
                  !_vm.exceedance
                    ? _c("h4", { staticClass: "tips" }, [
                        _vm._v(
                          "If you don't receive an email within 5 minutes, click below to resend."
                        ),
                      ])
                    : _vm._e(),
                  !_vm.exceedance
                    ? _c("h4", { staticClass: "tips mt60" }, [
                        _vm._v("Didn't receive an email? "),
                        !_vm.isResend
                          ? _c("span", { on: { click: _vm.resendEmail } }, [
                              _vm._v("Resend"),
                            ])
                          : _c("span", { staticClass: "is-resend" }, [
                              _vm._v(
                                "Resend in " + _vm._s(_vm.countdownResult) + "s"
                              ),
                            ]),
                      ])
                    : _vm._e(),
                  _vm.exceedance
                    ? _c("h4", { staticClass: "tips red2" }, [
                        _vm._v(
                          "You've reached the resend limit. Please try again in 24 hours."
                        ),
                      ])
                    : _vm._e(),
                  _vm.exceedance
                    ? _c("h4", { staticClass: "tips" }, [
                        _vm._v(
                          "For immediate assistance, contact our customer service."
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === "checkLink",
                      expression: "active === 'checkLink'",
                    },
                  ],
                  staticClass: "login-form",
                },
                [
                  _vm._m(3),
                  _vm._m(4),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "100%",
                        "margin-bottom": "30px",
                        "font-weight": "600",
                      },
                      attrs: {
                        loading: _vm.loading,
                        type: "info",
                        size: "default",
                      },
                      on: { click: _vm.requestNewLink },
                    },
                    [_vm._v("Request New Link")]
                  ),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === "resetPassword",
                      expression: "active === 'resetPassword'",
                    },
                  ],
                  ref: "resetForm",
                  staticClass: "login-form",
                  attrs: {
                    model: _vm.resetForm,
                    "auto-complete": "on",
                    "label-position": "top",
                  },
                },
                [
                  _c("div", { staticClass: "title-container" }, [
                    _c("h3", { staticClass: "title" }, [
                      _vm._v("Reset Your Password"),
                    ]),
                    _c("h4", { staticClass: "tips mb48" }, [
                      _vm._v("Please enter your new password."),
                    ]),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "login-form-item form-item-password",
                      attrs: {
                        prop: "new_password",
                        label: "New Password",
                        rules: {
                          validator: _vm.checkPasswordLength,
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        key: _vm.passwordType,
                        ref: "password",
                        staticClass: "login-input",
                        attrs: {
                          type: _vm.passwordType ? "text" : "password",
                          placeholder: "New Password",
                          name: "password",
                          tabindex: "2",
                          "auto-complete": "on",
                          size: "default",
                        },
                        on: { input: _vm.changePassword },
                        model: {
                          value: _vm.resetForm.new_password,
                          callback: function ($$v) {
                            _vm.$set(_vm.resetForm, "new_password", $$v)
                          },
                          expression: "resetForm.new_password",
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "show-pwd",
                          on: {
                            click: function ($event) {
                              return _vm.showPwd("passwordType", "password")
                            },
                          },
                        },
                        [
                          _c("svg-icon", {
                            attrs: {
                              "icon-class": !_vm.passwordType
                                ? "eye"
                                : "eye-open",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "login-form-item",
                      attrs: {
                        prop: "confirm_password",
                        label: "Confirm Password",
                        rules: {
                          validator: _vm.validateConfirmPassword,
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        key: _vm.passwordType,
                        ref: "confirmPassword",
                        staticClass: "login-input",
                        attrs: {
                          type: _vm.confirmPasswordType ? "text" : "password",
                          placeholder: "Confirm Password",
                          name: "confirmPassword",
                          tabindex: "2",
                          "auto-complete": "on",
                          size: "default",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleResetPassword($event)
                          },
                        },
                        model: {
                          value: _vm.resetForm.confirm_password,
                          callback: function ($$v) {
                            _vm.$set(_vm.resetForm, "confirm_password", $$v)
                          },
                          expression: "resetForm.confirm_password",
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "show-pwd",
                          on: {
                            click: function ($event) {
                              return _vm.showPwd(
                                "confirmPasswordType",
                                "confirmPassword"
                              )
                            },
                          },
                        },
                        [
                          _c("svg-icon", {
                            attrs: {
                              "icon-class": !_vm.confirmPasswordType
                                ? "eye"
                                : "eye-open",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "100%",
                        "margin-bottom": "30px",
                        "font-weight": "600",
                      },
                      attrs: {
                        loading: _vm.loading,
                        type: "info",
                        size: "default",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleResetPassword($event)
                        },
                      },
                    },
                    [_vm._v("Save New Password")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.active === "updatedSuccessfully",
                      expression: "active === 'updatedSuccessfully'",
                    },
                  ],
                  staticClass: "login-form",
                },
                [
                  _vm._m(5),
                  _vm._m(6),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        width: "100%",
                        "margin-bottom": "30px",
                        "font-weight": "600",
                      },
                      attrs: {
                        loading: _vm.loading,
                        type: "info",
                        size: "default",
                      },
                      on: { click: _vm.goLogin },
                    },
                    [_vm._v("Go to Login")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm.isPhone
      ? _c(
          "div",
          { staticClass: "xs-login-container" },
          [
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === "inputEmail",
                    expression: "active === 'inputEmail'",
                  },
                ],
                ref: "emailForm",
                staticClass: "xs-login-form",
                attrs: {
                  model: _vm.emailForm,
                  "auto-complete": "on",
                  "label-position": "top",
                },
              },
              [
                _c("div", { staticClass: "title-container" }, [
                  _c("h3", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.reset
                          ? "Request Password Reset"
                          : "Forgot your password?"
                      )
                    ),
                  ]),
                  _c("h4", { staticClass: "tips mb48" }, [
                    _vm._v(
                      "Enter your email address below, and we'll send you a link to reset your password."
                    ),
                  ]),
                ]),
                _c(
                  "el-form-item",
                  {
                    staticClass: "login-form-item mb48",
                    attrs: {
                      prop: "email",
                      label: "Email",
                      rules: { validator: _vm.validateEmail, trigger: "blur" },
                    },
                  },
                  [
                    _c("el-input", {
                      ref: "email",
                      staticClass: "login-input",
                      attrs: {
                        placeholder: "Email Address",
                        name: "email",
                        type: "text",
                        tabindex: "1",
                        "auto-complete": "on",
                        size: "default",
                      },
                      model: {
                        value: _vm.emailForm.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.emailForm, "email", $$v)
                        },
                        expression: "emailForm.email",
                      },
                    }),
                    _c(
                      "h4",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isNotRegistered,
                            expression: "isNotRegistered",
                          },
                        ],
                        staticClass: "tips red",
                      },
                      [
                        _vm._v(
                          "The email you entered is not registered. Please try again."
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "100%",
                      "margin-bottom": "30px",
                      "font-weight": "600",
                    },
                    attrs: {
                      loading: _vm.loading,
                      type: "info",
                      size: "default",
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.sendResetLink($event)
                      },
                    },
                  },
                  [_vm._v("Send Reset Link")]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === "checkEmail",
                    expression: "active === 'checkEmail'",
                  },
                ],
                staticClass: "xs-login-form",
              },
              [
                _vm._m(7),
                _vm._m(8),
                !_vm.exceedance
                  ? _c("h4", { staticClass: "tips" }, [
                      _vm._v(
                        "If you don't receive an email within 5 minutes, click below to resend."
                      ),
                    ])
                  : _vm._e(),
                !_vm.exceedance
                  ? _c("h4", { staticClass: "tips mt60" }, [
                      _vm._v("Didn't receive an email? "),
                      !_vm.isResend
                        ? _c("span", { on: { click: _vm.resendEmail } }, [
                            _vm._v("Resend"),
                          ])
                        : _c("span", { staticClass: "is-resend" }, [
                            _vm._v(
                              "Resend in " + _vm._s(_vm.countdownResult) + "s"
                            ),
                          ]),
                    ])
                  : _vm._e(),
                _vm.exceedance
                  ? _c("h4", { staticClass: "tips red2" }, [
                      _vm._v(
                        "You've reached the resend limit. Please try again in 24 hours."
                      ),
                    ])
                  : _vm._e(),
                _vm.exceedance
                  ? _c("h4", { staticClass: "tips" }, [
                      _vm._v(
                        "For immediate assistance, contact our customer service."
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === "checkLink",
                    expression: "active === 'checkLink'",
                  },
                ],
                staticClass: "xs-login-form",
              },
              [
                _vm._m(9),
                _vm._m(10),
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "100%",
                      "margin-bottom": "30px",
                      "font-weight": "600",
                    },
                    attrs: {
                      loading: _vm.loading,
                      type: "info",
                      size: "default",
                    },
                    on: { click: _vm.requestNewLink },
                  },
                  [_vm._v("Request New Link")]
                ),
              ],
              1
            ),
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === "resetPassword",
                    expression: "active === 'resetPassword'",
                  },
                ],
                ref: "resetForm",
                staticClass: "xs-login-form",
                attrs: {
                  model: _vm.resetForm,
                  "auto-complete": "on",
                  "label-position": "top",
                },
              },
              [
                _c("div", { staticClass: "title-container" }, [
                  _c("h3", { staticClass: "title" }, [
                    _vm._v("Reset Your Password"),
                  ]),
                  _c("h4", { staticClass: "tips mb48" }, [
                    _vm._v("Please enter your new password."),
                  ]),
                ]),
                _c(
                  "el-form-item",
                  {
                    staticClass: "login-form-item form-item-password",
                    attrs: {
                      prop: "new_password",
                      label: "New Password",
                      rules: {
                        validator: _vm.checkPasswordLength,
                        trigger: ["blur", "change"],
                      },
                    },
                  },
                  [
                    _c("el-input", {
                      key: _vm.passwordType,
                      ref: "password",
                      staticClass: "login-input",
                      attrs: {
                        type: _vm.passwordType ? "text" : "password",
                        placeholder: "New Password",
                        name: "password",
                        tabindex: "2",
                        "auto-complete": "on",
                        size: "default",
                      },
                      on: { input: _vm.changePassword },
                      model: {
                        value: _vm.resetForm.new_password,
                        callback: function ($$v) {
                          _vm.$set(_vm.resetForm, "new_password", $$v)
                        },
                        expression: "resetForm.new_password",
                      },
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "show-pwd",
                        on: {
                          click: function ($event) {
                            return _vm.showPwd("passwordType", "password")
                          },
                        },
                      },
                      [
                        _c("svg-icon", {
                          attrs: {
                            "icon-class": !_vm.passwordType
                              ? "eye"
                              : "eye-open",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "login-form-item",
                    attrs: {
                      prop: "confirm_password",
                      label: "Confirm Password",
                      rules: {
                        validator: _vm.validateConfirmPassword,
                        trigger: ["blur", "change"],
                      },
                    },
                  },
                  [
                    _c("el-input", {
                      key: _vm.passwordType,
                      ref: "confirmPassword",
                      staticClass: "login-input",
                      attrs: {
                        type: _vm.confirmPasswordType ? "text" : "password",
                        placeholder: "Confirm Password",
                        name: "confirmPassword",
                        tabindex: "2",
                        "auto-complete": "on",
                        size: "default",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleResetPassword($event)
                        },
                      },
                      model: {
                        value: _vm.resetForm.confirm_password,
                        callback: function ($$v) {
                          _vm.$set(_vm.resetForm, "confirm_password", $$v)
                        },
                        expression: "resetForm.confirm_password",
                      },
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "show-pwd",
                        on: {
                          click: function ($event) {
                            return _vm.showPwd(
                              "confirmPasswordType",
                              "confirmPassword"
                            )
                          },
                        },
                      },
                      [
                        _c("svg-icon", {
                          attrs: {
                            "icon-class": !_vm.confirmPasswordType
                              ? "eye"
                              : "eye-open",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "100%",
                      "margin-bottom": "30px",
                      "font-weight": "600",
                    },
                    attrs: {
                      loading: _vm.loading,
                      type: "info",
                      size: "default",
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleResetPassword($event)
                      },
                    },
                  },
                  [_vm._v("Save New Password")]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.active === "updatedSuccessfully",
                    expression: "active === 'updatedSuccessfully'",
                  },
                ],
                staticClass: "xs-login-form",
              },
              [
                _vm._m(11),
                _vm._m(12),
                _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "100%",
                      "margin-bottom": "30px",
                      "font-weight": "600",
                    },
                    attrs: {
                      loading: _vm.loading,
                      type: "info",
                      size: "default",
                    },
                    on: { click: _vm.goLogin },
                  },
                  [_vm._v("Go to Login")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-img" }, [
      _c("img", {
        staticStyle: { width: "49%" },
        attrs: {
          src: require("@/assets/login/pc_img_logo_forgot_password_paycools.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "email-img" }, [
      _c("img", {
        attrs: { src: require("@/assets/login/email_img.svg"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container" }, [
      _c("h3", { staticClass: "title mt60" }, [_vm._v("Check Your Email")]),
      _c("h4", { staticClass: "tips" }, [
        _vm._v("We've sent instructions to reset your password."),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "link-img" }, [
      _c("img", {
        attrs: { src: require("@/assets/login/link_img.svg"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container mt60" }, [
      _c("h3", { staticClass: "title" }, [_vm._v("Reset Link Expired")]),
      _c("h4", { staticClass: "tips mb48" }, [
        _vm._v(
          "The password reset link you used has expired. Please request a new link to reset your password."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "updated-successfully-img" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/login/updated_successfully.svg"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container mt60" }, [
      _c("h3", { staticClass: "title" }, [
        _vm._v("Password Updated Successfully"),
      ]),
      _c("h4", { staticClass: "tips mb48" }, [
        _vm._v(
          "Your password has been reset. You can now log in with your new password."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "email-img" }, [
      _c("img", {
        attrs: { src: require("@/assets/login/email_img.svg"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container" }, [
      _c("h3", { staticClass: "title mt60" }, [_vm._v("Check Your Email")]),
      _c("h4", { staticClass: "tips" }, [
        _vm._v("We've sent instructions to reset your password."),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "link-img" }, [
      _c("img", {
        attrs: { src: require("@/assets/login/link_img.svg"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container mt60" }, [
      _c("h3", { staticClass: "title" }, [_vm._v("Reset Link Expired")]),
      _c("h4", { staticClass: "tips mb48" }, [
        _vm._v(
          "The password reset link you used has expired. Please request a new link to reset your password."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "updated-successfully-img" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/login/updated_successfully.svg"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-container mt60" }, [
      _c("h3", { staticClass: "title" }, [
        _vm._v("Password Updated Successfully"),
      ]),
      _c("h4", { staticClass: "tips mb48" }, [
        _vm._v(
          "Your password has been reset. You can now log in with your new password."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }